import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  lat = 42.450416;
  lng = 18.535103;
  zoom = 18;
  scrollwheel = false;

  constructor(private translate: TranslateService) { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact.component.ts